import QuestionModel from "../QuestionModel";
import QuestionValue from "../QuestionValue";
import QuestionValuePercentage from "../QuestionValuePercentage";
import QuestionValueRatio from "../QuestionValueRatio";
import QuestionValueRatio3 from "../QuestionValueRatio3";
import QuestionModule from "./QuestionModule";

export default class QuestionModuleRatio extends QuestionModule {
    constructor() {
        super();
    }

    create(data) {
        const question = super.create(data);
        this.generate(question, data);
        return question;
    }

    generate(question, data) {
        switch (question.type) {
            case QuestionModel.TYPE_RATIO_SIMPLE : {
                this.generateSimple(question, data);
                break;
            }
            case QuestionModel.TYPE_RATIO_SIMPLE_TRIPLE : {
                this.generateSimpleTriple(question, data);
                break;
            }
            case QuestionModel.TYPE_RATIO_PERCENT : {
                this.generatePercent(question, data);
                break;
            }
            case QuestionModel.TYPE_RATIO_FIND_RAT : {
                this.generateFindRatio(question, data);
                break;
            }
            case QuestionModel.TYPE_RATIO_FIND_VAL : {
                this.generateFindValue(question, data);
                break;
            }
            case QuestionModel.TYPE_RATIO_SIMPLIFY : {
                this.generateSimplifyRatio(question, data);
                break;
            }
        }
    }

    generateSimple(question, data) {
        /*
            You cast 2 plague spells for every 5 ruin spells. If you cast 60 ruin spells,
            how many plague spells do you cast?
        */

        // "numerator_range": {"min": 4, "max": 8},
        // "denominator_range": {"min": 2, "max": 4},
        //  "range": {"min": 2, "max": 4},

        //safe fallback for new features
        if (!data.numerator_range) {
            data.numerator_range = {"min": 4, "max": 8};
        }
        if (!data.denominator_range) {
            data.denominator_range = {"min": 2, "max": 4};
        }

        const numerator = P3.math.randomInt(data.numerator_range.min, data.numerator_range.max);//plague quantity
        const denominator = P3.math.randomInt(data.denominator_range.min, data.denominator_range.max);//rune quantity

        const ratio = new QuestionValueRatio(numerator, denominator);
        const scalar = P3.math.randomInt(data.range.min, data.range.max);

        question.values.push(new QuestionValue(numerator));
        question.values.push(new QuestionValue(denominator));

        const displayed = new QuestionValue(denominator * scalar);
        question.values.push(displayed);

        const answer = new QuestionValue(numerator * scalar);

        question.options.push(answer);

        //add the answer as last value
        question.values.push(answer);
        question.part = 3;

        let k = 100;
        let arr = [];
        while (k-- > 0 && question.options.length < 5) {
            const rand = answer.value + P3.math.randomInt(-4, 10);
            if (arr.indexOf(rand) === -1 && rand !== answer.value) {
                arr.push(rand);
                question.options.push(new QuestionValue(rand));
            }
        }

        P3.utils.shuffleArray(question.options);
    }

    generateSimpleTriple(question, data) {
        /*
            The ratio of hobgoblins to nightstalkers to dragons is 5:3:1.
            There are 65 hobgoblins. How many nightstalkers are there?
        */
        const totalA = P3.math.randomInt(question.range.min, question.range.max);
        const totalB = P3.math.randomInt(question.range.min, question.range.max);
        const totalC = P3.math.randomInt(question.range.min, question.range.max);

        const ratio = new QuestionValueRatio3(totalA, totalB, totalC);
        question.values.push(ratio);

        const scale = P3.math.randomInt(2, 8);
        const overall = (totalA + totalB + totalC) * scale;

        question.values.push(new QuestionValue(totalA * scale));
        question.values.push(new QuestionValue(totalB * scale));

        question.part = 2;

        question.options.push(question.answer);

        let k = 100;
        let arr = [question.answer.value];
        while (k-- > 0 && question.options.length < 5) {
            const rand = question.answer.value + P3.math.randomInt(-10, 20);
            if (arr.indexOf(rand) === -1) {
                arr.push(rand);
                question.options.push(new QuestionValue(rand));
            }
        }

        P3.utils.shuffleArray(question.options);
    }

    generatePercent(question, data) {
        //If I have 50 coins and 10 of them are silver what percentage are gold?
        let attempts = 100;

        //struggling with recurring percentages, just brute forcing it here instead because can't think of a smart way of ovoiding recurring (e.g. 6:9 as a percent)
        let answerValue = 0.1;//set to any float
        while (answerValue % 1 !== 0 && attempts-- > 0) {

            question.values = [];
            question.options = [];

            const denominator = P3.math.randomInt(question.range.min, question.range.max);
            const numerator = denominator * Math.round(P3.math.randomInt(2, 6));

            question.values.push(new QuestionValue(numerator));
            question.values.push(new QuestionValue(denominator));

            const answer = new QuestionValuePercentage(numerator - denominator, numerator);
            answerValue = answer.value * 100;

            question.options.push(answer);

            //add the answer as last value
            question.values.push(answer);
            question.part = 2;

            //console.log("ANSWER : " + answer.toString());

            let k = 100;
            let arr = [];
            while (k-- > 0 && question.options.length < 5) {
                let randomPercent = P3.math.randomInt(1, 9);
                if (Math.random() < 0.3) randomPercent += 0.5;
                let rand = new QuestionValuePercentage(randomPercent, 10);
                if (arr.indexOf(rand.value) === -1 && rand.value !== answer.value) {
                    arr.push(rand.value);
                    question.options.push(rand);
                }
            }

            P3.utils.shuffleArray(question.options);
        }
    }

    generateFindRatio(question, data) {
        //Two of these five [elves] are red and the rest are green. What is the proportion of red [elves]? [2/5]
        const total = P3.math.randomInt(question.range.min, question.range.max);

        const numerator = total - P3.math.randomInt(1, Math.floor(total * 0.5));
        const denominator = total - numerator;

        question.values.push(new QuestionValue(numerator));
        question.values.push(new QuestionValue(denominator));
        question.values.push(new QuestionValue(total));

        question.plural = true;
        question.pluralIndices = [];

        if (numerator === 1) {
            question.plural = false;
            question.pluralIndices.push(0);
        }
        if (denominator === 1) {
            question.plural = false;
            question.pluralIndices.push(1);
        }

        // / console.log(numerator);
        //  console.log(denominator);
        ///  console.log(total);

        //keep dividing ratio down until wont divide roundly
        const reducedRatio = reduce(numerator, denominator);
        const ratio = new QuestionValueRatio(reducedRatio.n, reducedRatio.d);

        question.values.push(ratio);
        question.part = 3;

        question.options.push(ratio);

        let k = 100;
        let arr = [];
        while (k-- > 0 && question.options.length < 5) {
            let n = Math.abs(numerator + P3.math.randomInt(-6, 6));
            let d = Math.abs(denominator + P3.math.randomInt(-6, 6));
            if (n === 0) n += 1;
            if (d === 0) d += 1;

            const reduced = reduce(n, d);
            const rand = new QuestionValueRatio(reduced.n, reduced.d);
            if (arr.indexOf(rand.value) === -1 && rand.value !== ratio.value) {
                arr.push(rand.value);
                question.options.push(rand);
            }
        }

        P3.utils.shuffleArray(question.options);

        // Reduce a fraction by finding the Greatest Common Divisor and dividing by it.
        function reduce(numerator, denominator) {
            let gcd = function gcd(a, b) {
                return b ? gcd(b, a % b) : a;
            };
            gcd = gcd(numerator, denominator);
            return {n: numerator / gcd, d: denominator / gcd};
        }
    }

    generateFindValue(question, data) {
        //You agree with the [ranger] to split the weapons between you in the ratio 4:5. There are 405 weapons altogether. How many weapons do you keep?
        const totalRatio = P3.math.randomInt(question.range.min, question.range.max);

        let numerator = Math.floor(P3.math.randomInt(1, totalRatio * 0.5));
        let denominator = totalRatio - numerator;

        const reducedRatio = reduce(numerator, denominator);

        numerator = reducedRatio.n;
        denominator = reducedRatio.d;

        const ratio = new QuestionValueRatio(numerator, denominator);
        question.values.push(ratio);

        const total = (numerator + denominator) * totalRatio;
        question.values.push(new QuestionValue(total));

        const divisor = numerator + denominator;

        const scaled = total / divisor;
        const answer = new QuestionValue(scaled * denominator);//todo - can easily extend this to allow working out left hand side, just multiply by numerator instead

        question.options.push(answer);

        //console.warn(numerator + ", " + denominator);
       // const left = scaled * numerator;
      //  const right = answer.value;

        //console.log("LEFT : " + left + ", RIGHT : " + right);

        question.values.push(answer);
        question.part = 2;
        // console.log("answer : " + answer);

        let k = 100;
        let arr = [];
        while (k-- > 0 && question.options.length < 5) {
            const rand = new QuestionValue(Math.abs(answer.value + P3.math.randomInt(-question.range.max * 0.5, question.range.max * 0.5)));
            if (arr.indexOf(rand.value) === -1 && rand.value !== answer.value && rand.value !== 0) {
                arr.push(rand.value);
                question.options.push(rand);
            }
        }

        P3.utils.shuffleArray(question.options);

        // Reduce a fraction by finding the Greatest Common Divisor and dividing by it.
        function reduce(numerator, denominator) {
            let gcd = function gcd(a, b) {
                return b ? gcd(b, a % b) : a;
            };
            gcd = gcd(numerator, denominator);
            return {n: numerator / gcd, d: denominator / gcd};
        }
    }

    generateSimplifyRatio(question, data) {
        //Two of these six [elves] are red and the rest are green - that's a ratio of 2:4.
        // Can you simplify that ratio? [1:2]
        if (!data.scale) data.scale = {min: 2, max: 6};
        const scale = P3.math.randomInt(data.scale.min, data.scale.max);


        const total = P3.math.randomInt(question.range.min, question.range.max);

        const numerator = Math.floor(P3.math.randomInt(2, (total - 1) * 0.5));
        const denominator = total - numerator;

        //const total = numerator * denominator * totalRatio;

        //  const ratio = new QuestionValue(total / denominator);
        question.values.push(new QuestionValue(numerator * scale));
        question.values.push(new QuestionValue(denominator * scale));
        question.values.push(new QuestionValue(total * scale));

        const displayedRatio = new QuestionValueRatio(numerator * scale, denominator * scale);//todo - can easily extend this to allow working out left hand side, just multiply by numerator instead
        question.values.push(displayedRatio);
        //question.values.push(new QuestionValueRatio(numerator * scale, denominator * scale));

        //  const divisor = numerator + denominator;

        //  const scaled = total / divisor;

        const reducedRatio = reduce(numerator, denominator);

        const answer = new QuestionValueRatio(reducedRatio.n, reducedRatio.d);
        question.values.push(answer);
        question.part = 4;


        question.options.push(answer);

        //  console.log("numerator : " + numerator + ", denominator : " + denominator + ", total : " + total);
        //console.warn(numerator + ", " + denominator);
        //  const left = scaled * numerator;
        //  const right = answer.value;

        //console.log("LEFT : " + left + ", RIGHT : " + right);

        //console.log(answer);

        //question.values.push(answer);
        //  question.values.push(new QuestionValueRatio(numerator, denominator));

        // console.log("answer : " + answer);

        // console.warn(question.values);

        let k = 100;
        let arr = [];
        while (k-- > 0 && question.options.length < 5) {
            const rand = new QuestionValueRatio(P3.math.randomInt(2, 4), P3.math.randomInt(4, 8));
            if (arr.indexOf(rand.value) === -1 && rand.value !== answer.value) {
                arr.push(rand.value);
                question.options.push(rand);
            }
        }

        P3.utils.shuffleArray(question.options);

        // Reduce a fraction by finding the Greatest Common Divisor and dividing by it.
        function reduce(numerator, denominator) {
            let gcd = function gcd(a, b) {
                return b ? gcd(b, a % b) : a;
            };
            gcd = gcd(numerator, denominator);
            return {n: numerator / gcd, d: denominator / gcd};
        }
    }
}